const WORDS = [
  "Excellence",
  "Transparency",
  "Timely Delivery",
  "Craftsmanship",
  "Customer Satisfaction",
  "Landmark Living",
];

export default function MarqueeV2() {
  const line = WORDS.map((w, i) => (
    <span key={i} className="flex items-center gap-6 md:gap-8 px-4 md:px-6">
      <span className="font-serif-display italic text-[32px] md:text-[48px] lg:text-[64px] leading-none v2-marquee-word whitespace-nowrap">
        {w}
      </span>
      <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full v2-marquee-dot shrink-0" />
    </span>
  ));

  return (
    <section aria-hidden="true" data-testid="marquee-v2" className="relative bg-charcoal py-10 md:py-14 overflow-hidden border-y border-charcoal_ink/10">
      <div className="marquee-track">
        <div className="flex">{line}</div>
        <div className="flex">{line}</div>
      </div>
    </section>
  );
}
